module.exports = __webpack_public_path__ + "img/ico-telegram.5f088ac.svg";